export const BUTTON_STYLE = {
  GREEN: 'green',
  GREEN_DARK: 'green-dark',
  BLUE: 'blue',
  BLACK: 'black'
}
